import request from '@/utils/http'

const PREFIX = '/analyse/funnel'

const analyseFunnel = {
  create(params) {
    return request(
      `${PREFIX}/create`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  delete(id) {
    return request(
      `${PREFIX}/${id}`,
      'delete'
    )
  },

  list(param) {
    return request(
      `${PREFIX}/list`,
      'get',
      param
    )
  },

  get(id) {
    return request(
      `${PREFIX}/` + id,
      'get'
    )
  },

  listForm(params) {
    return request(
      `${PREFIX}/list/form`,
      'get',
      params
    )
  },

  getStep(id) {
    return request(
      `${PREFIX}/step/` + id,
      'get'
    )
  },

  analyseLeftChart(params, isqueue) {
    return request(
      `${PREFIX}/1${isqueue ? '/queue' : ''}`,
      'post',
      params
    )
  },

  analyseRightChart(params, isqueue) {
    return request(
      `${PREFIX}/2${isqueue ? '/queue' : ''}`,
      'post',
      params
    )
  },

  listEventParam(params) {
    return request(
      `${PREFIX}/list/param`,
      'get',
      params
    )
  }
}

export default analyseFunnel
